import assets from 'themes/base/assets';

export const CPU_FAMILY = {
  INTEL_SKYLAKE: {
    name: 'Intel Skylake',
    logo: assets.INTEL,
  },
  AMD_OPTERON: {
    name: 'AMD Opteron',
    logo: assets.AMD,
  },
  INTEL_XEON: {
    name: 'Intel Xeon',
    logo: assets.INTEL,
  },
};
